export const challengesData = [
  {
    title: "Infinite Scroll",
    duration: "45 minutes",
    difficultyLevel: "Medium",
    url: "https://cdn.prod.website-files.com/606170e8343bd733785eeea3/61d206ca94fc0869263ac998_developmen%20plan%20theme.png",
  },
  {
    title: "Pagination",
    duration: "45 minutes",
    difficultyLevel: "Medium",
    url: "https://cdn.prod.website-files.com/606170e8343bd733785eeea3/61d206ca94fc0869263ac998_developmen%20plan%20theme.png",
  },
  {
    title: "Live-chat",
    duration: "60 minutes",
    difficultyLevel: "Medium",
    url: "https://cdn.prod.website-files.com/606170e8343bd733785eeea3/61d206ca94fc0869263ac998_developmen%20plan%20theme.png",
  },
  {
    title: "Accordion",
    duration: "45 minutes",
    difficultyLevel: "Medium",
    url: "https://cdn.prod.website-files.com/606170e8343bd733785eeea3/61d206ca94fc0869263ac998_developmen%20plan%20theme.png",
  },
  {
    title: "Comments",
    duration: "45 minutes",
    difficultyLevel: "Medium",
    url: "https://cdn.prod.website-files.com/606170e8343bd733785eeea3/61d206ca94fc0869263ac998_developmen%20plan%20theme.png",
  },

  {
    title: "Config Driven UI",
    duration: "45 minutes",
    difficultyLevel: "Medium",
    url: "https://cdn.prod.website-files.com/606170e8343bd733785eeea3/61d206ca94fc0869263ac998_developmen%20plan%20theme.png",
  },
  {
    title: "Image Slider",
    duration: "45 minutes",
    difficultyLevel: "Medium",
    url: "https://cdn.prod.website-files.com/606170e8343bd733785eeea3/61d206ca94fc0869263ac998_developmen%20plan%20theme.png",
  },
  {
    title: "Theme Toggle",
    duration: "45 minutes",
    difficultyLevel: "Medium",
    url: "https://cdn.prod.website-files.com/606170e8343bd733785eeea3/61d206ca94fc0869263ac998_developmen%20plan%20theme.png",
  },
  {
    title: "Count Down Timer",
    duration: "45 minutes",
    difficultyLevel: "Medium",
    url: "https://cdn.prod.website-files.com/606170e8343bd733785eeea3/61d206ca94fc0869263ac998_developmen%20plan%20theme.png",
  },
  {
    title: "FAQs",
    duration: "45 minutes",
    difficultyLevel: "Medium",
    url: "https://cdn.prod.website-files.com/606170e8343bd733785eeea3/61d206ca94fc0869263ac998_developmen%20plan%20theme.png",
  },
  {
    title: "Mortgage Calculator",
    duration: "45 minutes",
    difficultyLevel: "Medium",
    url: "https://cdn.prod.website-files.com/606170e8343bd733785eeea3/61d206ca94fc0869263ac998_developmen%20plan%20theme.png",
  },

  {
    title: "Custom Modal Overlay",
    duration: "45 minutes",
    difficultyLevel: "Medium",
    url: "https://cdn.prod.website-files.com/606170e8343bd733785eeea3/61d206ca94fc0869263ac998_developmen%20plan%20theme.png",
  },
  {
    title: "Multi Step Form",
    duration: "45 minutes",
    difficultyLevel: "Medium",
    url: "https://cdn.prod.website-files.com/606170e8343bd733785eeea3/61d206ca94fc0869263ac998_developmen%20plan%20theme.png",
  },
  {
    title: "Auto Suggestion",
    duration: "90 minutes",
    difficultyLevel: "Medium",
    url: "https://cdn.prod.website-files.com/606170e8343bd733785eeea3/61d206ca94fc0869263ac998_developmen%20plan%20theme.png",
  },
  {
    title: "Bar Chart",
    duration: "90 minutes",
    difficultyLevel: "Medium",
    url: "https://cdn.prod.website-files.com/606170e8343bd733785eeea3/61d206ca94fc0869263ac998_developmen%20plan%20theme.png",
  },
  {
    title: "Pagination With Search",
    duration: "90 minutes",
    difficultyLevel: "Medium",
    url: "https://cdn.prod.website-files.com/606170e8343bd733785eeea3/61d206ca94fc0869263ac998_developmen%20plan%20theme.png",
  },
  {
    title: "MyPagination",
    duration: "45 minutes",
    difficultyLevel: "Medium",
    url: "https://cdn.prod.website-files.com/606170e8343bd733785eeea3/61d206ca94fc0869263ac998_developmen%20plan%20theme.png",
  },
];
